export default {
  dbi_mobile_device_reports: 'Mobile Device Reports',
  dbi_mobile_device_reports_intro: 'In this secion, we present you the Monthly Mobile Device reports.',

  dbi_reports_search_placeholder: 'Search for report title',
  dbi_reports_loading: 'Loading...',
  dbi_reports_loading_more: 'Loading more...',
  dbi_reports_no_data: 'No data under current selections.',

  dbi_insights_report: 'Insights Report',
  dbi_game_research_report: 'Game Research Report',
  dbi_insights_report_intro: 'Get market insights from our experienced content creators in the game industry.',
  dbi_game_research_report_intro:
    'Presented here are reports powered by the Game Research Center (GRC), feel free to contact leenxu@tencent.com or donbli@tencent.com for more details.',
  dbi_insights_report_search: 'Search any topics/tags',
  dbi_insights_report_search_or_tag: 'Search Any Topic/Tag',
  dbi_insights_report_search_recent: 'Recent',
  dbi_insights_report_search_no_data: 'No Data',
  dbi_insights_report_like: 'Like',
  dbi_insights_report_share: 'Share',
  dbi_insights_report_general_game: 'General Gaming',
  dbi_insights_report_esports: 'Esports',
  dbi_insights_report_market: 'Market',
  dbi_insights_report_game_genres: 'Game & Genres',
  dbi_insights_report_players: 'Players',
  dbi_insights_report_monetization: 'Monetization',
  dbi_insights_report_compliance: 'Compliance',

  // Insights Center Reports IIC中心报告
  dbi_insights_center_library: 'Insights Center Reports',
  dbi_insights_center_library_intro:
    'In this section, we present you English reports powered by Infinite Insight Center (IIC). Please contact huidonghe@tencent.com for further information.',
  dbi_insights_center_library_fundamental_study: 'Fundamental Study',
  dbi_insights_center_library_grip: 'GRIP Report',
  dbi_insights_center_library_grip_competitor_analysis: 'Competitor Analysis',
  dbi_insights_center_library_grip_marker_event_recap: 'Market Event Recap',
  // dbi_insights_center_library_ad_hoc_research: 'Ad-Hoc Research',
  dbi_insights_center_library_regional_monthly_report: 'Regional Monthly Report',
  dbi_insights_center_library_regional_monthly_report_na: 'NA',
  dbi_insights_center_library_regional_monthly_report_eu: 'EU',
  dbi_insights_center_library_regional_monthly_report_mena: 'MENA',
  dbi_insights_center_library_regional_monthly_report_latam: 'LATAM',

  dbi_imur_reports: 'iMur Reports',
  dbi_imur_reports_intro:
    'In this section, we present you reports powered by Market & User Research Group (iMur), please check more details on iMur pages.',
  dbi_imur_reports_intro_global:
    'Dear users, to gain access of iMur reports, please contact teresalv@tencent.com from the iMur team through your Pteam member.',
  dbi_imur_reports_report_type: 'Report type',

  dbi_imur_reports_tab_white_paper: 'White Papers',
  dbi_imur_reports_tab_monitoring_reports: 'Monitoring Reports',
  dbi_imur_reports_tab_genres: 'Genres & Competitors',
  dbi_imur_reports_tab_operation: 'Operation & Publishing',
  dbi_imur_reports_tab_specific: 'Specific Reports',
  dbi_imur_reports_tab_game_companies: 'Game Compaines',
  dbi_imur_reports_tab_new_tech: 'New Tech',

  dbi_imur_NA: 'NA',
  dbi_imur_EU: 'EU',
  dbi_imur_LATAM: 'LATAM',
  dbi_imur_SEA: 'SEA',
  dbi_imur_MENA: 'MENA',
  dbi_imur_Japan: 'Japan',
  'dbi_imur_W.EU': 'W.EU',
  dbi_imur_EA: 'EA',
  'dbi_imur_Turkey & Russia': 'Turkey & Russia',
  dbi_imur_SA: 'SA',
  dbi_imur_Africa: 'Africa',
  dbi_imur_GR: 'Genre Rerearch',
  dbi_imur_CR: 'Competitor Research',
  dbi_imur_CM: 'Competitiors Monitoring',
  dbi_imur_SR: 'Specific Research',
  dbi_imur_GC: 'Game Companies',
  'dbi_imur_VR/AR': 'VR/AR',
  dbi_imur_Metaverse: 'Metaverse',

  dbi_market_report: 'Markets Reports',
  'dbi_market_report-download': 'Excel Version',

  dbi_reports_lang_chi: 'Chinese Report',
  dbi_reports_lang_eng: 'English Report',
  dbi_reports_all: 'All',
  dbi_reports_liked: 'Liked',
  dbi_reports_search_na_data: 'Sorry, please try other key words for search.',
  dbi_iic_reports_search_na_data:
    'The reports under the current section are in planning, and please stay tuned for the upcoming reports.',

  dbi_insight_report_feedback_tips: 'Thank you for your feedback!',
  dbi_insight_report_share_success_tips1: 'Link has been successfully copied!',
  dbi_insight_report_share_success_tips2: 'Check out this {type} report!',
  dbi_report_share_success_insight: 'insight',
  dbi_report_share_success_insight_center_library: 'insights center reports',
  dbi_report_share_success_game_analysis: 'game analysis',
  dbi_report_share_success_game_research: 'game research',
  dbi_insight_report_load_failure_tips: 'Reported loading failure',
  dbi_insight_report_deleted_tips: 'The report has been deleted.',
  dbi_insight_report_reload_tips: 'Please try again',
  dbi_insight_center_library_report_unavailable_download:
    'Unavailable to download the current report as requested by owner, please contact {email} to learn more details.',
  dbi_game_analysis_report_title: 'Game Analysis',
  dbi_game_analysis_report_sub_title: 'This module contains insightful game analysis reports.',
  dbi_segment_english_report: 'English Report',
  dbi_segment_french_report: 'French Report',
  dbi_segment_italian_report: 'Italian Report',
  dbi_segment_german_report: 'German Report',
  dbi_segment_spanish_report: 'Spanish Report',
  dbi_segment_chinese_report: 'Chinese Report',
  dbi_segment_japanese_report: 'Japanese Report',
  dbi_segment_korean_report: 'Korean Report',
  dbi_segment_portuguese_report: 'Portuguese Report',
  dbi_segment_russian_report: 'Russian Report',
  dbi_segment_polish_report: 'Polish Report',
  dbi_segment_arabic_report: 'Arabic Report',
  dbi_segment_turkish_report: 'Turkish Report',
  dbi_segment_thai_report: 'Thai Report',
  dbi_segment_vietnamese_report: 'Vietnamese Report',
  dbi_segment_indonesian_report: 'Indonesian Report',
  dbi_reports_likes: 'Likes',
  dbi_reports_views: 'Views',
  dbi_reports_upload_time: 'Upload Time',

  dbi_reports_email_copy_success: 'Successful replication',
  dbi_reports_email_copy_failed: 'Failed replication, please try again.',

  dbi_reports_casual_games_reports_title: 'Casual Games Reports',
  dbi_reports_casual_games_reports_sub_title: 'We present you selected reports related to casual games',
  dbi_reports_market_reports: 'Market Reports',
  dbi_reports_analysis_reports: 'Analysis Reports',

  dbi_report_search_title: 'Report Search',
  dbi_report_search_placeholder: 'Searching anything in game industry, including AI',
  dbi_report_search_button: 'Search',
  dbi_report_search_section_searching: 'Searching...',
  dbi_report_search_stats_total_reports: 'Reports',
  dbi_report_search_stats_popular_games: 'Popular Games Covered',
  dbi_report_search_stats_data_sources: 'Report Vendors',
  dbi_report_search_stats_ai_practices: 'Game AI Practices',
  dbi_report_search_section_latest: 'Latest Reports',
  dbi_report_search_section_popular: 'Popular Reports',
  dbi_report_search_recent_title: 'Recents',
  dbi_report_search_no_recent: 'No search record',
  dbi_report_search_no_data: 'No data',
  dbi_report_search_no_data_desc_line1: "We couldn't find what you searched for.",
  dbi_report_search_no_data_desc_line2: 'Try searching again.',
  dbi_report_search_empty_title: 'No Reports Yet',
  dbi_report_search_empty_desc: 'Reports are being prepared. Please check back later.',
};
